import { render } from "./noticedetail.vue?vue&type=template&id=07097d84&scoped=true&ts=true"
import script from "./noticedetail.vue?vue&type=script&lang=ts"
export * from "./noticedetail.vue?vue&type=script&lang=ts"

import "./noticedetail.vue?vue&type=style&index=0&id=07097d84&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07097d84"]])

export default __exports__